import { render, staticRenderFns } from "./ArchivedOrderListItem.vue?vue&type=template&id=088de4ee&"
import script from "./ArchivedOrderListItem.vue?vue&type=script&lang=ts&"
export * from "./ArchivedOrderListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports